<template>
    <main-content>
        <div class="d-flex align-items-center justify-content-between">
            <page-title
                :title_text="'سرویس فاکتور آنلاین'"
                :icon="'money_request'"
            >
            </page-title>
            <div class="d-flex">
              <router-link to="/pardakht-shakhsi" class="btn btn-success mx-1">تنظیمات</router-link>
                <!--           <div class=" py-1">-->
                <!--                <router-link to="/customers" class="btn btn-outline-success m-1"-->
                <!--                    >مشتریان</router-link-->
                <!--                >-->
                <!--           </div>-->
                <!--           <div class=" py-1">-->
                <!--                <router-link to="/items" class="btn btn-outline-success m-1"-->
                <!--                    >سبد محصولات</router-link-->
                <!--                >-->
                <!--           </div>-->
                <!--           <div class="py-1">-->

                <!--           </div>-->
            </div>
        </div>

        <div class="row mt-5">
          <div class="col-sm">
            <div class="bg-white shadow-sm my-2" style="border-radius: 20px">
              <div class="card-body">
                <div class="p-3">
                  <div class="ml-4">
                    <h4 class="h4 text-dark bg-white mb-3">فاکتور آنلاین</h4>
                    <p class="text-dark-50">
                      جایگزینی مناسب برای فاکتورهای کاغذی که میتوانید از طریق پیامک به مشتریانتان جهت پرداخت هزینه محصولات به صورت آنلاین، ارسال کنید. همچنین میتوانید برای مدیریت و دریافت منظم پرداخت‌های دوره‌ای از فاکتورآنلاین زمان‌بندی شده استفاده کنید.
                    </p>
                  </div>
                  <hr class="my-3" />
                  <div class="d-flex flex-wrap sm-online-factor">
                    <div class="mr-6 mt-1 ml-lg-0 ml-xxl-6 flex-shrink-0">
                      <router-link to="/online-factor-factor-create" class="btn btn-success mx-1" >ایجاد فاکتور</router-link>
                    </div>
                    <div class="mr-6 mt-1 ml-lg-0 ml-xxl-6 flex-shrink-0">
                      <router-link to="/factors" class="btn btn-outline-success mx-1" > لیست فاکتور ها</router-link>
                    </div>
                    <div class="mr-6 mt-1 ml-lg-0 ml-xxl-6 flex-shrink-0">
                      <router-link to="/customers" class="btn btn-outline-success mx-1" > مشتریان</router-link>
                    </div>
                    <div class="mr-6 mt-1 ml-lg-0 ml-xxl-6 flex-shrink-0">
                      <router-link to="/items" class="btn btn-outline-success mx-1" >سبد محصولات</router-link>
                    </div>
                    <div class="mr-6 mt-1 ml-lg-0 ml-xxl-6 flex-shrink-0">
                      <router-link to="/online-factor/discounts" class="btn btn-outline-success mx-1">لیست تخفیف ها</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="col-sm"></div>
        </div>
        <div id="qr_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog modal-width">
                <!-- Modal content-->
                <div class="modal-content">
                    <pardakht-shakhsi></pardakht-shakhsi>
                </div>
            </div>
        </div>
    </main-content>
</template>

<script>
import MainContent from '@/components/main-content';
import PageTitle from '@/components/main/components/pageTitle';
import PardakhtShakhsi from '@/pages/receive-money/pardakht-shakhsi';
import { mapGetters } from 'vuex';
import { gatewayStatus } from '@/constants/gatewayStatus';

export default {
    name: 'Get',
    components: {
        PardakhtShakhsi,
        PageTitle,
        MainContent
    },
    data() {
        return {
            gateway_status: gatewayStatus,
            active_pardakhtyari_count: 0,
            pending_pardakhtyari_count: 0
        };
    },
    mounted() {
        this.$store.dispatch('gateway/fetch');
    },
    computed: {
        ...mapGetters('gateway', ['gateways', 'status'])
    },
    watch: {
        status: function (val) {
            if (val == 'success') {
                for (let g in this.gateways) {
                    if (this.gateways[g].gateway_type === 0) {
                        if (
                            this.gateways[g].status ===
                            this.gateway_status.ACTIVE
                        ) {
                            ++this.active_pardakhtyari_count;
                        } else if (
                            this.gateways[g].status ===
                                this.gateway_status.PENDING ||
                            this.gateways[g].status ===
                                this.gateway_status.SEND_TO_SHAPARAK
                        ) {
                            ++this.pending_pardakhtyari_count;
                        }
                    }
                }
            }
        }
    }
};
</script>

<style scoped>
@media screen and (max-width: 678px) {
    .sm-online-factor {
        flex-wrap: wrap;
    }
    .sm-online-factor div {
        margin: 0.3rem 0;
    }
    .sm-online-factor button {
        margin: 0.3rem 0;
    }

    .sm-online-factor a {
        margin: 0.3rem 0;
    }
}
</style>
